// extracted by mini-css-extract-plugin
export default {"value":"PileParametersSection_value__rpz5M","wrapper":"PileParametersSection_wrapper__3mw6U"};